export class BasePage {
    constructor({recipe, vars, hdrs}) {
      this.recipe = recipe;
      this.vars = vars;
      this.hdrs = hdrs;
    }
}